import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FooterComponent } from './shared/footer/footer.component';
import { NavbarComponent } from './shared/navbar/navbar.component';

import { InicioComponent } from './components/inicio/inicio.component';
import { DataConnectService } from './services/data-connect.service';
import { AsignarComponent } from './components/asignar/asignar.component';
import { ListadoasignarComponent } from './components/listadoasignar/listadoasignar.component';
import { DetalleOirsComponent } from './components/detalle-oirs/detalle-oirs.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogService } from './services/confirm-dialog.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragToSelectModule } from 'ngx-drag-to-select';
import { SortByPipe } from './pipes/sort-by.pipe';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { VisualizarComponent } from './components/visualizar/visualizar.component';
import { LoginComponent } from './components/login/login.component';
import { DatePipe } from '@angular/common';
import { from } from 'rxjs';
import { JwtInterceptorService } from './services/jwt-interceptor.service';


@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    NavbarComponent,
    ConfirmDialogComponent,
    InicioComponent,
    AsignarComponent,
    ListadoasignarComponent,
    DetalleOirsComponent,
    SortByPipe,
    VisualizarComponent,
    LoginComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    DragToSelectModule.forRoot(),
    AngularEditorModule
  ],
  entryComponents: [ ConfirmDialogComponent],
  providers: [ { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
               DataConnectService, ConfirmDialogService,DatePipe
             ],
  bootstrap: [AppComponent]
})
export class AppModule { }
